<template>
    <div>
        <vs-row class="cardGeneral">
            <vs-col class="cardReportes" vs-type="flex" vs-justify="center" vs-align="center" w="12">          
                <h4 class="p-2">Reporte dinámico de facturación</h4>
                <vs-row class="mt-4">
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label for="institucion" class="labelInput">
                                Institución
                            </label>
                            <vs-select filter class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" v-if="instituciones.length" :disabled="!instituciones.length" autocomplete="off">
                                <template #message-danger v-if="errorFields.includes('institucion')">
                                    Requerido
                                </template>
                                <template v-if="instituciones.length">
                                    <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                                </template>
                                <template v-else>
                                    <vs-option label="No hay datos" :value="0">
                                        No hay datos
                                    </vs-option>
                                </template>
                            </vs-select>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <label for="inicio" class="labelInput">
                            Fecha inicio
                        </label>
                        <vs-input
                        class="pt-0"
                        type="date"
                        v-model="inicio"
                        required="required"
                        id="inicio"
                        name="fecha">
                            <template #message-danger v-if="errorFields.includes('inicio')">
                                Requerido
                            </template>
                        </vs-input>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <label for="fin" class="labelInput">
                            Fecha final
                        </label>
                        <vs-input
                        :disabled="!inicio"
                        @input="comparaFechas()"
                        class="pt-0"
                        type="date"
                        v-model="fin"
                        required="required"
                        id="fin"
                        :min="inicio"
                        name="fecha">
                            <template #message-danger v-if="errorFecha">
                                La fecha es menor a la inicial. Selecciona otra fecha distinta.
                            </template>
                        </vs-input>
                        <div v-if="fin !== ''" @click="fin = ''" class="tache">
                            <i class="far fa-times-circle"></i>
                        </div>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label for="statu" class="labelInput">
                                Tipo de consulta
                            </label>
                            <vs-select filter class="aqui pt-0" id="statu" placeholder="Seleccionar tipo de consulta" v-model="statu" v-if="status.length" :disabled="!status.length" autocomplete="off">
                                <template #message-danger v-if="errorFields.includes('statu')">
                                    Requerido
                                </template>
                                <template>
                                    <vs-option label="Factura timbrada" value="timbrado">
                                        Factura timbrada
                                    </vs-option>
                                    <vs-option label="Factura cancelada" value="cancelado">
                                        Factura cancelada
                                    </vs-option>
                                    <vs-option label="Ingresos vs Facturas" value="ingresosvsfacturas">
                                        Ingresos vs Facturas
                                    </vs-option>
                                </template>
                            </vs-select>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <div class="d-flex " style="justify-content: space-between;">
                            <label for="codigoDetalle" class="labelInput">
                                Código de detalle
                            </label>
                            <div class="d-flex" v-if="codigosDetalle[0]">
                                <div> 
                                    <vs-tooltip>
                                        <i class="fas fa-check-square" style="cursor:pointer" @click="selectAll(codigosDetalle, 'codigosDetalle')"></i>
                                        <template #tooltip>
                                            Seleccionar todo
                                        </template>
                                    </vs-tooltip>
                                </div>
                                <div class="labelInput">
                                    <vs-tooltip>
                                        <i class="far fa-times-circle" style="cursor:pointer" @click="deseleccionarAll('codigosDetalle')"></i>
                                        <template #tooltip>
                                            Deseleccionar todo
                                        </template>
                                    </vs-tooltip>
                                </div>
                                
                            </div>
                        </div>
                        <vs-select
                            filter
                            multiple
                            collapse-chips
                            class="pt-0"
                            id="codigoDetalle"
                            placeholder="Seleccionar Código de detalle"
                            v-model="codigoDetalle"
                            :key="codigosDetalleId"
                            :disabled="!codigosDetalle.length"
                        >
                            <vs-option v-for="option in codigosDetalle" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label for="factura" class="labelInput">
                                Tipo de factura
                            </label>
                            <vs-select filter class="aqui pt-0" id="factura" placeholder="Seleccionar tipo de factura" :key="facturaId" v-model="factura" v-if="facturas.length" :disabled="!facturas.length" autocomplete="off">
                                <template v-if="facturas.length">
                                    <vs-option v-for="option in facturas" :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                                </template>
                                <template v-else>
                                    <vs-option label="No hay datos" :value="0">
                                        No hay datos
                                    </vs-option>
                                </template>
                            </vs-select>
                            <div v-if="factura !== ''" @click="factura = ''" class="tache">
                                <i class="far fa-times-circle"></i>
                            </div>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <label for="folio" class="labelInput">
                            Búsqueda por UUID
                        </label>
                        <vs-input
                            type="text"
                            v-model="buscar_uuid"
                            id="folio"
                            class="pt-0"
                        />
                        <div v-if="buscar !== ''" @click="buscar = ''" class="tache">
                            <i class="far fa-times-circle"></i>
                        </div>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <label for="folio" class="labelInput">
                            <vs-tooltip>
                                Búsqueda general <i class="fas fa-exclamation-circle"></i>
                                <template #tooltip>
                                    Podrá buscar por: uuid, matrícula, apellido paterno, apellido materno, nombres, razon social (padre de familia), correo fiscal y RFC.
                                </template>
                            </vs-tooltip>
                        </label>
                        <vs-input
                            type="text"
                            v-model="buscar"
                            id="folio"
                            class="pt-0"
                        />
                        <div v-if="buscar !== ''" @click="buscar = ''" class="tache">
                            <i class="far fa-times-circle"></i>
                        </div>
                    </vs-col>
                </vs-row>
                <vs-row  class="mb-5">
                    <vs-col sm="12" lg="3" style="display: flex; margin-left: auto">
                        <vs-button
                            @click="getInfoFacturas('online')"
                            class="ml-auto"
                        >
                            <i class="fas fa-search mr-2"></i>Buscar
                        </vs-button>
                    </vs-col>
                </vs-row>
                <vs-button
                    v-if="users != ''"
                    color="#55ce63"
                    relief
                    :loading="loadingExcel"
                    @click="getFacturacionExcel()"
                    class="ml-auto"
                >
                    <i class="fas fa-download mr-2"></i> Descargar reporte
                </vs-button>
                <vs-alert v-if="alerta === 'mostrar'">
                    <template #title>
                        No hay información
                    </template>
                    Prueba colocando otros filtros
                </vs-alert>
                <tabla @refreshTableFactura="getInfoFacturas" :users="users" :institucion="institucion" :status="statu" :cards="cards" :personaRol="personaRol"></tabla>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import buscador from './buscador'
import tabla from './tabla-facturacion'
import reportes from '../../../../api/requests/reportes.js'
export default {
    props: [
        'personaRol'
    ],
    data(){
        return{
            codigoDetalle: '',
            codigosDetalle: [],
            codigosDetalleId: (new Date()).getTime(),
            institucion: '',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            statu: '',
            status: [],
            statuId: (new Date()).getTime(),
            factura: '',
            facturas: [],
            facturaId: (new Date()).getTime(),
            inicio: '',
            fin:'',
            folio: '',
            buscar: '',
            buscar_uuid: '',
            users: [],
            alerta: '',
            loadingExcel: false,
            errorFields:[],
            cards: [],
            errorFecha: false
        }
    },
    components:{
        buscador,
        tabla
    },
    async created(){
        this.getInstituciones()
        this.getConceptos()
        this.getCFDI()
        this.getTipoFactura()
    },
    methods:{
        comparaFechas(){
            setTimeout(() => {
            if (this.inicio > this.fin) {
                this.errorFecha = true
            }else{
                this.errorFecha = false
            }
            }, 1000);
        },
        selectAll(seleccion, tipo){
              let arr = []
            seleccion.forEach(i => {
              arr.push(i.id)
            })
            if(tipo == 'codigosDetalle'){
                this.codigoDetalle = arr
            }
        },
        deseleccionarAll(tipo){
            if(tipo == 'codigosDetalle'){
                this.codigoDetalle = ''
            }
        },
        async getInstituciones(){
            try {
                const response = await reportes.getInstitucion()
                this.instituciones = response.data
            }
            catch{
                
            }
        },
        async getConceptos(){
            try {
                const response = await reportes.getConceptos()
                this.codigosDetalle = response.data.opciones
                this.codigosDetalleId = (new Date()).getTime()
            }
            catch{
                
            }
        },
        async getCFDI(){
            try {
                const response = await reportes.getCFDI()
                this.status = response.data.opciones

            }
            catch{
                
            }
        },
        async getTipoFactura(){
            try {
                const response = await reportes.getTipoFactura()
                this.facturas = response.data.opciones

            }
            catch{
                
            }
        },
        
        sanityForm () {
            this.errorFields = []
            if (!this.inicio) {
                this.errorFields.push('inicio')
            }
            if (!this.statu) {
                this.errorFields.push('statu')
            }
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if (!this.errorFields.length){

                return true
            } else {
                return null
            }
        },

        async getInfoFacturas(tipo){
            const params = this.sanityForm()
            if(params == true && this.errorFecha == false){
                

                let params = {
                    "inicio": this.inicio,
                    "institucion": this.institucion,
                    "type_response": "online",
                }
                if(this.fin !== ''){
                    params.fin = this.fin
                }
                if(this.codigoDetalle !== ''){
                    if(this.codigoDetalle[0] == ''){
                        const eliminarcodigoDetalle = this.codigoDetalle.shift()
                        params.conceptos = this.codigoDetalle
                    }else{
                        params.conceptos = this.codigoDetalle
                    }
                }
                if(this.buscar !== ''){
                    params.texto = this.buscar
                }
                if(this.factura !== ''){
                    params.tipo_factura = this.factura
                }
                if(this.folio !== ''){
                    params.uuid = this.folio
                }
                if(this.buscar_uuid != ''){
                    params.buscar_uuid = this.buscar_uuid
                }

                params.estatus = this.statu

                const loading = this.$vs.loading()
                try{
                    const response = await reportes.getInfoFacturas(params)
                    this.users = response.data.data
                    this.cards = response.data.estadisticas
                    loading.close()
                    if(!this.users[0]){
                        this.alerta = "mostrar"
                    }else{
                        this.alerta = ''
                    }
                }catch{
                    loading.close() 
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'ALgo salio mal',
                    })
                }
            }
        },
        async getFacturacionExcel(){
            const loading = this.$vs.loading()
            try{

                let params = {
                    "inicio": this.inicio,
                    "institucion": this.institucion,
                    "type_response": "file",
                }
                if(this.fin !== ''){
                    params.fin = this.fin
                }
                if(this.codigoDetalle !== ''){
                    if(this.codigoDetalle[0] == ''){
                        const eliminarcodigoDetalle = this.codigoDetalle.shift()
                        params.conceptos = this.codigoDetalle
                    }else{
                        params.conceptos = this.codigoDetalle
                    }
                }
                if(this.buscar !== ''){
                    params.texto = this.buscar
                }
                if(this.factura !== ''){
                    params.tipo_factura = this.factura
                }
                if(this.folio !== ''){
                    params.uuid = this.folio
                }

                params.estatus = this.statu
                this.loadingExcel = true
                const response = await reportes.getInfoFacturas(params)
                loading.close()
                if(response){
                    window.location.href = response.request.responseURL;
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: 'bottom-right',
                        title: 'Éxito',
                        text: 'Descarga lista'
                    })
                    this.loadingExcel = false
                }
            }catch(error){
                console.log(error)
                loading.close() 
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'ALgo salio mal',
                })
            }
        },
    },
}
</script>
<style lang="scss" scoped>
    .cardReportes{
        width: 100%;
        background-color:white;
        justify-content: space-between;
        @media only screen and (max-width: 768px) {
            margin: 16px;
        }
        @media only screen and (min-width: 768px) {
            margin: 16px 30px;
        }
        border-radius: 3px;
        padding: 10px
    }
    .cardGeneral{
        @media only screen and (max-width: 768px) {
            width: 85%;
        }
        @media only screen and (min-width: 768px) {
            width: 95%;
        }
    }
    
    .tache{
        position: absolute;
        cursor: pointer;
        top: 35px;
        @media only screen and (max-width: 768px) {
            left: calc(95% - 4em);
        }
        @media only screen and (min-width: 768px) {
            left: calc(98% - 4em);
        }

    }
    .cien {
        width: 100px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .cienCincuenta {
        width: 150px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }

    .mdChip{
        background: rgba($color: #000000, $alpha: 0.5);
        margin:1.7% 0;
        padding: 2% 6%;
        text-align: center;
        border-radius: 15px;
        font-size: 11px;
    }

</style>
<style>
    .vs-input--folio{
        width: 100% !important;
    }
    
    .red {
        color: red;
        padding-left: 15px;
    }
</style>